import { createContext } from "react";
import { PaneSize } from "./PaneSize";

export const PaneSizeContext = createContext<PaneSize | null>(null);
